import $ from 'jquery';
import UI from 'root/ui';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    events: {
        'click button[data-val="feedback_comment"]' : 'onToggle',
        'click button[data-val="feedback_vote"]'    : 'onToggle',
        'click button[data-val="unsubscribe"]'      : 'onUnsubscribe',
        'click .confirm-email'                      : 'onConfirmEmail'
    },

    dom_handlers: {
        onToggle: function(e) {
            if ($(e.currentTarget).hasClass('switch-on')) {
                $(e.currentTarget).removeClass('switch-on').addClass('switch-off');
            } else {
                if (!Cache.portal_user.get('is_email_confirmed')) {
                    this.conformEmail();
                    return;
                }

                $(e.currentTarget).removeClass('switch-off').addClass('switch-on');
            }

            var notifications = [];
            if (this.$el.find('button[data-val="feedback_comment"]').hasClass('switch-on')) {
                notifications.push('feedback_comment');
            }
            if (this.$el.find('button[data-val="feedback_vote"]').hasClass('switch-on')) {
                notifications.push('feedback_vote');
            }

            Cache.app.request({
                action: 'notification/savePortal',
                data: {
                    notifications: notifications
                },
                success: function(response) {
                    UI.success('Notification settings updated');
                    Cache.notification.reset(response);
                }
            });
        },

        onUnsubscribe: function(e) {
            if ($(e.currentTarget).hasClass('switch-on')) {
                $(e.currentTarget).removeClass('switch-on').addClass('switch-off');
            } else {
                $(e.currentTarget).removeClass('switch-off').addClass('switch-on');
            }

            if ($(e.currentTarget).hasClass('switch-on')) {
                this.$el.find('.switch-on[data-val="feedback_comment"]').removeClass('switch-on').addClass('switch-off');
                this.$el.find('.switch-on[data-val="feedback_vote"]').removeClass('switch-on').addClass('switch-off');

                this.$el.find('button[data-val="feedback_comment"]').prop('disabled', true);
                this.$el.find('button[data-val="feedback_vote"]').prop('disabled', true);

                Cache.app.request({
                    action: 'notification/unsubscribe',
                    success: function() {
                        UI.success('Notification settings updated');
                        Cache.notification.remove(Cache.notification.models);
                        Cache.portal_user.set('unsubscribe_all', true);
                    }
                });
            } else {
                this.$el.find('button[data-val="feedback_comment"]').prop('disabled', false);
                this.$el.find('button[data-val="feedback_vote"]').prop('disabled', false);

                Cache.app.request({
                    action: 'notification/subscribe',
                    success: function() {
                        UI.success('Notification settings updated');
                        Cache.portal_user.set('unsubscribe_all', false);
                    }
                });
            }
        },

        onConfirmEmail: function(e) {
            e.preventDefault();
            this.conformEmail();
        }
    },

    conformEmail: function(e) {
        Modals.sendEmailConfirmation();
    },

    render: function() {
        var content =
        '<div>Send an email to me (<b>' + (Cache.portal_user.get('email')) + '</b>) when:</div>' +

        (Cache.portal_user.get('is_email_confirmed') ? '' :
        '<div class="margin-top-4 font-weight-medium">' +
            '<a class="confirm-email warning" href="#"><i class="fas fa-exclamation-circle margin-right-4"></i>Confirm my email address</a>' +
        '</div>') +

        '<div class="divider-12"></div>' +
        '<hr class="small">' +
        '<div class="notification-settings">' +
            '<button type="button" class="small ' + (Cache.notification.findWhere({action: 'feedback_comment'}) ? 'switch-on' : 'switch-off') + '" data-val="feedback_comment"></button>' +
            '<div class="title">New Comments</div>' +
            '<div class="text-info">When someone replies to me</div>' +
        '</div>' +
        '<hr class="small">' +
        '<div class="notification-settings">' +
            '<button type="button" class="small ' + (Cache.notification.findWhere({action: 'feedback_vote'}) ? 'switch-on' : 'switch-off') + '" data-val="feedback_vote"></button>' +
            '<div class="title">Vote</div>' +
            '<div class="text-info">When someone votes on my idea</div>' +
        '</div>' +
        '<hr class="small">' +
        '<div class="notification-settings">' +
            '<button type="button" class="small ' + (Cache.portal_user.get('unsubscribe_all') ? 'switch-on' : 'switch-off') +  '" data-val="unsubscribe"></button>' +
            '<div class="title">Unusbscribe All</div>' +
            '<div class="text-info">Do not send me any notifications</div>' +
        '</div>' +
        '<hr class="small">';

        this.$el.html(content);

        if (Cache.portal_user.get('unsubscribe_all')) {
            this.$el.find('.switch-on[data-val="feedback_comment"]').removeClass('switch-on').addClass('switch-off');
            this.$el.find('.switch-on[data-val="feedback_vote"]').removeClass('switch-on').addClass('switch-off');

            this.$el.find('button[data-val="feedback_comment"]').prop('disabled', true);
            this.$el.find('button[data-val="feedback_vote"]').prop('disabled', true);
        }

        return this;
    }
});